function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 7.51878L9.62405 15L23 2",
  stroke: "#494B4E",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 17,
  viewBox: "0 0 25 17",
  fill: "none"
}, props), _ref);

export default __webpack_public_path__ + "static/media/check.f626bf02.svg";
export { SvgComponent as ReactComponent };